import React from 'react';
import { connect } from 'react-redux';
import { newRequestUrl, requestUrl } from '@/constants/urls';
import DropdownItem from '@/components/DropdownItem';
import StandardToolsMenu from '@/components/tools/StandardToolsMenu';
import { showDeleteRequest, showTransferRequest } from '../actions';
import { requestAccessContext, accessControlAsRequester } from '../helper';
import { requestSourceEntities, requestTransferTypes } from '../constants';

const RequestTools = ({
  allowAudit,
  allowClone,
  allowDelete,
  allowRead,
  allowTransfer,
  category,
  isAuto,
  listItem = false,
  newRequestCode,
  request,
  showDelete,
  showTransfer,
  upward,
  url,
}) => (
  <StandardToolsMenu
    allowDelete={allowDelete}
    allowRead={allowRead}
    href={url}
    listItem={listItem}
    onDelete={() => showDelete(category, request.code)}
    upward={upward}
  >
    {allowClone && (
    <DropdownItem
      icon="clone"
      textId="actions.duplicate"
      href={newRequestUrl(requestSourceEntities.REQUEST, request.code, newRequestCode, '#')}
    />
    )}
    {allowTransfer && (
    <DropdownItem
      icon={isAuto ? 'exchange' : 'checkmark'}
      textId={isAuto ? 'actions.transfer' : 'actions.complete'}
      onClick={() => showTransfer(category, request.code)}
    />
    )}
    {allowAudit && (<DropdownItem icon="history" textId="actions.audit" href={`${requestUrl(request, '#')}/audits`} />)}
  </StandardToolsMenu>
);

const mapStateToProps = ({
  requests: {
    newRequestCode,
  },
  auth: {
    role,
    currentUser,
  },
}, { request }) => (
  {
    newRequestCode,
    ...accessControlAsRequester(requestAccessContext(request, currentUser), role),
    isAuto: request.transfer.transfer_type !== requestTransferTypes.MANUAL,
  }
);

const mapDispatchToProps = {
  showDelete: showDeleteRequest,
  showTransfer: showTransferRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(RequestTools);
